module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_sundsvall-9f323f1be95e8e45f7420b359f904f22.png";